/**
 * Created by vladislav on 10.09.2019
 */

const LanternView = cc.Node.extend({
    ctor: function (lantern, parent) {
        this._super();

        this.lantern = lantern;

        this.setAnchorPoint(0.5, 0.5);
        this.setLocalZOrder(2);
        this.styles = cleverapps.styles.LanternView;

        this.animation = new cleverapps.Spine(bundles.lantern.jsons.lantern_json);
        this.addChild(this.animation);
        this.setContentSize2(this.animation.getContentSize());
        this.animation.setAlignment(this.width / 2, this.height / 2);

        parent = parent || Game.currentGame.field.onGetView();
        parent.addChild(this);
    },

    show: function () {
        this.animation.setAnimation(0, `idle_${this.lantern.getCurrentStreak()}`, true);
        const startPosition = this.getParent().convertToNodeSpace(cc.p(-this.width, 0));
        if (!startPosition.x) {
            startPosition.x = 0;
        }
        startPosition.y = this.styles.show.y;
        const scale = 1 / this.parent.scale;
        const offsetX = this.styles.offset.x * (scale < 1 ? scale : 1);
        const offsetY = this.styles.offset.y * (scale < 1 ? scale : 1);
        const targetPosition = cc.p(this.parent.width / 2 + offsetX, this.parent.height / 2 + offsetY);
        this.setAlignment(startPosition);

        if (cleverapps.config.name === "heroes") {
            this.runAction(new cc.MoveTo(0.5, targetPosition));
        } else {
            this.setRotation(45);
            this.runAction(new cc.Spawn(
                new cc.MoveTo(0.5, targetPosition),
                new cc.RotateTo(0.5, 0)
            ));
        }

        cleverapps.effects.fire("mission.lantern.show");
    },

    hide: function () {
        const hidePosition = this.getParent().convertToNodeSpace(cc.p(-this.width, 0));
        hidePosition.y = this.styles.hide.y;
        this.animation.setAnimation(0, `out_${this.lantern.getCurrentStreak()}`, false);
        this.animation.setCompleteListener(() => {
            this.animation.setAnimation(0, `idle_${this.lantern.getCurrentStreak()}`, true);

            let action = new cc.Spawn(
                new cc.MoveTo(0.5, hidePosition),
                new cc.RotateTo(0.4, -45)
            );
            if (cleverapps.config.name === "heroes") {
                action = new cc.MoveTo(0.5, hidePosition);
            }

            this.runAction(new cc.Sequence(
                action,
                new cc.RemoveSelf()
            ));
        });

        cleverapps.effects.fire("mission.lantern.hide");
    }
});

cleverapps.styles.LanternView = {
    offset: {
        x: 0,
        y: 150
    },
    show: {
        y: 100
    },
    hide: {
        y: 1000
    }
};